import axios from '@/axiosInterceptor';
import dayjs from 'dayjs';

const state = () => ({
  isLaneSearchHistoryLoading: false,
  isLoadsLoading: false,
  loads: [],
  dispatch: [],
  transit: [],
  completed: [],
  existing_dispatch_query: '',
  existing_transit_query: '',
  existing_completed_query: '',
  dispatch_pagination: {
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
  },
  transit_pagination: {
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
  },
  completed_pagination: {
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
  },
  loadboard_pagination: {
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
  },
  eld_carrier_vehicles: [],
  load_logs: [],
  load_details: {},
  isLoadDetailsLoading: false,
  assigned_vehicle: {},
  destination_route: {},
  destination_route_loading: false,
  load_route_loading: false,
  load_route_distance: {},
  load_route_distance_loading: false,
  load_route: {},
  has_assigned_vehicle_loaded: false,
  has_near_by_vehicles_loaded: false,
  near_by_vehicles: [],
  user_ticket_role: null,
  alert_vehicles: [],
  has_load_logs_loaded: false,
  has_alert_vehicles_loaded: true,
  dispatch_filters: {
    equipment: [],
    origin: '',
    destination: '',
  },
  transit_filters: {
    equipment: [],
    origin: '',
    destination: '',
  },
  completed_filters: {
    equipment: [],
    origin: '',
    destination: '',
  },
  loadSearchFilters: {},
  dispatch_params: {},
  transit_params: {},
  completed_params: {},
  current_load_status: 'dispatch',
  search_load_error: {},
  brokerTypeAheadResults: [],
  isBrokerNameAutocompleteLoading: false,
  lane_search_history: [],
  equipment_types: [],
  is_truck_postings_loading: false,
  truck_postings: [],
  truck_postings_pagination: {
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
  },
  is_create_truck_posting_loading: false,
  expired_truck_postings: [],
  expired_truck_postings_pagination: {
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
  },
  is_expired_truck_posting_loading: false,
  truck_posting_error: {},
  preloaded_load_response: {},
  is_carrier_connect_button_loading: false,
});

const getLoadLogsScope = (type) => {
  switch (type) {
    case 'physical_location_out_of_range_from_origin':
      return {
        data: 'setAlertVehicles',
        loaded: 'setHasAlertVehiclesLoaded',
        query: '?q[is_type_eq]=physical_location_out_of_range_from_origin',
      };
    case 'load_updates':
      return {
        data: 'setLoadLogs',
        loaded: 'setHasLoadLogsLoaded',
        query: `?q[external_message_not_eq]=null&q[category_or_is_type_in][]=load_created&q[category_or_is_type_in][]=material_changes&q[category_or_is_type_in][]=carrier_assigned&q[category_or_is_type_in][]=carrier_changed&q[category_or_is_type_in][]=carrier_vehicle_tms_assigned&q[category_or_is_type_in][]=received_tms_vehicle_and_found`,
      };
    case 'tracking_updates':
      return {
        data: 'setLoadLogs',
        loaded: 'setHasLoadLogsLoaded',
        query: `?q[external_message_not_eq]=null&q[is_type_in][]=ping_successful&q[is_type_in][]=tracking_ended&q[is_type_in][]=carrier_vehicle_assigned&q[is_type_in][]=ping_successful_no_update&q[is_type_in][]=arrived_at_stop&q[is_type_in][]=departed_stop&q[is_type_in][]=inner_stop_geofence_break&q[is_type_in][]=outer_stop_geofence_break`,
      };
    case 'comments':
      return {
        data: 'setLoadLogs',
        loaded: 'setHasLoadLogsLoaded',
        query: '?q[external_message_not_eq]=null&q[is_type_in][]=comments',
      };
    default:
      return {
        data: 'setLoadLogs',
        loaded: 'setHasLoadLogsLoaded',
        query: '?q[external_message_not_eq]=null',
      };
  }
};

const loadsScope = {
  dispatch: {
    setResults: 'setDispatchLoads',
    setQuery: 'setDispatchQuery',
    existingQuery: 'existing_dispatch_query',
    setPagination: 'setDispatchPagination',
  },
  transit: {
    setResults: 'setTransitLoads',
    setQuery: 'setTransitQuery',
    existingQuery: 'existing_transit_query',
    setPagination: 'setTransitPagination',
  },
  completed: {
    setResults: 'setCompletedLoads',
    setQuery: 'setCompletedQuery',
    existingQuery: 'existing_completed_query',
    setPagination: 'setCompletedPagination',
  },
};
const getRouteScope = (type) => {
  switch (type) {
    case 'destination':
      return {
        data: 'setDestinationRoute',
        loading: 'setDestinationRouteLoading',
      };
    case 'origin':
      return {
        data: 'setOriginRoute',
        loading: 'setOriginRouteLoading',
      };
    default:
      return {
        data: 'setLoadRoute',
        loading: 'setLoadRouteLoading',
      };
  }
};

const sortHash = {
  price_asc: 'min_rate asc',
  price_desc: 'min_rate desc',
  posting_asc: 'last_posted_at asc',
  posting_desc: 'last_posted_at desc',
  rpm: 'rate_per_mile desc',
  distance_asc: 'posted_miles asc',
  distance_desc: 'posted_miles desc',

  // TODO -- below needs setup
  pickup_asc: 'pickup_time asc',
  pickup_desc: 'pickup_time desc',
  dropoff_asc: 'dropoff_time asc',
  dropoff_desc: 'dropoff_time desc',
};

function parseLocalizedNumber(str) {
  if (typeof str !== 'string') return NaN;
  return Number(str.replace(/[^\d.-]/g, ''));
}

const buildLoadSearchQueryParams = (query, sort) => {
  let params = {
    can_be_posted_true: 1,
  };

  if (sort) {
    params.s = sortHash[sort];
  } else {
    delete params.s;
  }

  if (query.equipment && query?.equipment?.length > 0) {
    params.equipment_type_in = query.equipment;
  } else {
    delete params.equipment_type_in;
  }
  if (query.trailer && query?.trailer?.length > 0) {
    params.equipment_type_in = query.trailer;
  } else if (!query.equipment) {
    delete params.equipment_type_in;
  }

  if (query.min_rate) {
    params.min_rate_gteq = parseInt(query.min_rate);
  }
  if (query.weight) {
    const weight = parseLocalizedNumber(query.weight);
    params.weight_gteq = parseInt(weight);
    params.weight_unit_eq = 'lbs';
  } else {
    delete params.weight_gteq;
    delete params.weight_unit_eq;
  }

  if (query.trailer_length) {
    params.trailer_length_gteq = parseInt(query.trailer_length);
    // params.trailer_length_unit_eq = 'ft';
  } else {
    delete params.trailer_length_gteq;
    // delete params.trailer_length_unit_eq;
  }

  if (query.origin_area_id) {
    params.origin_area_id = query.origin_area_id;

    if (!params.origin_deadhead) {
      params.origin_deadhead_distance_miles = '150';
    }
  } else {
    delete params.origin_deadhead_distance_miles;
  }

  if (query.destination_area_id) {
    params.destination_area_id = query.destination_area_id;

    if (!params.destination_deadhead) {
      params.destination_deadhead_distance_miles = '150';
    }
  } else {
    delete params.destination_deadhead_distance_miles;
  }

  if (query.origin) {
    params.origin_search_display_name = query.origin;
  } else {
    delete params.origin_search_display_name;
  }

  if (query.destination) {
    params.destination_search_display_name = query.destination;
  } else {
    delete params.destination_search_display_name;
  }

  if (query.pickup_start) {
    params.start_stop_scheduled_window_started_at_date_gteq = dayjs(
      query.pickup_start
    ).format('YYYY-MM-DD');
    params.start_stop_scheduled_window_started_at_date_lteq = dayjs(
      query.pickup_start
    ).format('YYYY-MM-DD');
  }
  // TODO --- look into if this is needed
  if (query.pickup_end) {
    params.start_stop_scheduled_window_started_at_date_lteq = dayjs(
      query.pickup_end
    ).format('YYYY-MM-DD');
  }

  if (query.dropoff_start) {
    params.end_stop_scheduled_window_started_at_date_gteq = dayjs(
      query.dropoff_start
    ).format('YYYY-MM-DD');
    params.end_stop_scheduled_window_started_at_date_lteq = dayjs(
      query.dropoff_start
    ).format('YYYY-MM-DD');
  }

  if (query.dropoff_end) {
    params.end_stop_scheduled_window_started_at_date_lteq = dayjs(
      query.dropoff_end
    ).format('YYYY-MM-DD');
  }

  if (query.deadhead) {
    const deadhead = query.deadhead?.replace(' mi', '');
    params.origin_deadhead_distance_miles = parseInt(deadhead);
  }

  if (query.origin_deadhead) {
    params.origin_deadhead_distance_miles = query.origin_deadhead?.replace(
      ' mi',
      ''
    );
  }

  if (query.destination_deadhead) {
    params.destination_deadhead_distance_miles =
      query.destination_deadhead?.replace(' mi', '');
  }

  if (query.posting) {
    if (query?.posting.includes('8hr')) {
      // less than 8hr
      params.last_posted_at_gteq = dayjs().subtract(8, 'hour');
    } else if (query?.posting.includes('12hr')) {
      // between 8 - 12 hours
      params.last_posted_at_lteq = dayjs().subtract(8, 'hour');
      params.last_posted_at_gteq = dayjs().subtract(12, 'hour');
    } else if (query?.posting.includes('24hr')) {
      // between 12 - 24 hours
      params.last_posted_at_lteq = dayjs().subtract(12, 'hour');
      params.last_posted_at_gteq = dayjs().subtract(24, 'hour');
    } else if (query?.posting.includes('72hr')) {
      // between 24 - 72 hours
      params.last_posted_at_lteq = dayjs().subtract(24, 'hour');
      params.last_posted_at_gteq = dayjs().subtract(72, 'hour');
    } else if (query?.posting.includes('>72hr')) {
      // greater than 72 hours
      params.last_posted_at_lteq = dayjs().subtract(72, 'hour');
    }
  }

  if (query.status) {
    params.broker_connection_status = 'In Network';
    // if (query.status?.includes('In Network')) {
    //   params.broker_connection_status = 'In Network';
    // } else {
    //   params.broker_connection_status = 'Out of Network';
    // }
  } else {
    delete params.broker_connection_status;
  }

  if (query.hazmat) {
    params.is_hazmat_required_true = 1;
  } else {
    delete params.is_hazmat_required_true;
  }
  if (query.teams) {
    params.is_teams_required_true = 1;
  } else if (!query.equipment) {
    delete params.is_teams_required_true;
  }

  if (query.searchQuery) {
    params.broker_legal_name_cont = query.searchQuery;
  } else if (!query.searchQuery) {
    delete params.broker_legal_name_cont;
  }

  if (query.company_id) {
    params.company_id_eq = query.company_id;
  } else if (!query.company_id) {
    delete params.company_id_eq;
  }

  return params;
};

// actions
const actions = {
  async getLoads(
    { commit, state },
    {
      page = 1,
      query = '',
      status = 'dispatch',
      sort = 'start_stop_scheduled_window_started_at+asc',
      refetch = false,
      useExisting = false,
    }
  ) {
    if (!refetch) {
      commit('setLoading', true);
    }

    const params = `?q[s]=${sort}&page=${page}${query}`;
    const existingParams = state?.[loadsScope[status]?.existingQuery];
    const doesQueryMatch = params === existingParams;

    try {
      commit('setCurrentLoadStatus', status);

      if (state[status]?.length === 0 || (!doesQueryMatch && !useExisting)) {
        // const res = await axios.get(
        //   `${process.env.API_MONITOR}/api/v1/loads/carrier_index${query}`
        // );
        const res = await axios.get(
          `${process.env.API_MONITOR}/api/v1/loads${params}`
        );

        if ([200, 201, 204].includes(res?.status) && res.data) {
          if (refetch) {
            const combinedState = [...state[status], ...res.data];

            commit('setLoads', combinedState);
            commit(loadsScope[status]?.setResults, combinedState);
            commit(loadsScope[status]?.setQuery, params);
            commit(loadsScope[status]?.setPagination, {
              totalRecords: res.headers?.totalitems,
              totalPages: res.headers?.totalpages,
              currentPage: res.headers?.currentpage,
            });
          } else {
            commit('setLoads', res.data);
            commit(loadsScope[status]?.setResults, res.data);
            commit(loadsScope[status]?.setQuery, params);
            commit(loadsScope[status]?.setPagination, {
              totalRecords: res.headers?.totalitems,
              totalPages: res.headers?.totalpages,
              currentPage: res.headers?.currentpage,
            });
          }
        } else {
          throw new Error('No data returned from API', { cause: res });
        }
      } else {
        commit('setLoads', state[status]);
        // set pagination here as well
      }
    } catch (e) {
      console.log('error', e);
    } finally {
      commit('setLoading', false);
    }
  },
  async getLoadBoardLoads(
    { commit, state },
    {
      page = 1,
      query = '&q[posted]=1',
      status = 'dispatch',
      sort = 'start_stop_scheduled_window_started_at+asc',
      refetch = false,
      useExisting = false,
    }
  ) {
    if (!refetch) {
      commit('setLoading', true);
    }

    const params = `?q[s]=${sort}&page=${page}${query}`;
    const existingParams = state?.[loadsScope[status]?.existingQuery];
    const doesQueryMatch = params === existingParams;

    try {
      commit('setCurrentLoadStatus', status);

      // TODO -- come back to this, might be different from /loads
      //
      if (state[status]?.length === 0 || (!doesQueryMatch && !useExisting)) {
        // const res = await axios.get(
        //   `${process.env.API_MONITOR}/api/v1/loads/carrier_index${query}`
        // );
        const res = await axios.get(
          `${process.env.API_MONITOR}/api/v1/loads${params}`
        );

        if ([200, 201, 204].includes(res?.status) && res.data) {
          if (refetch) {
            const combinedState = [...state[status], ...res.data];

            commit('setLoads', combinedState);
            commit('setLoadboardPagination', {
              totalRecords: res.headers?.totalitems,
              totalPages: res.headers?.totalpages,
              currentPage: res.headers?.currentpage,
            });

            // TODO -- see what needs to be removed here
            commit(loadsScope[status]?.setResults, combinedState);
            commit(loadsScope[status]?.setQuery, params);
            commit(loadsScope[status]?.setPagination, {
              totalRecords: res.headers?.totalitems,
              totalPages: res.headers?.totalpages,
              currentPage: res.headers?.currentpage,
            });
          } else {
            commit('setLoads', res.data);
            commit('setLoadboardPagination', {
              totalRecords: res.headers?.totalitems,
              totalPages: res.headers?.totalpages,
              currentPage: res.headers?.currentpage,
            });
            commit(loadsScope[status]?.setResults, res.data);
            commit(loadsScope[status]?.setQuery, params);
            commit(loadsScope[status]?.setPagination, {
              totalRecords: res.headers?.totalitems,
              totalPages: res.headers?.totalpages,
              currentPage: res.headers?.currentpage,
            });
          }
        } else {
          throw new Error('No data returned from API', { cause: res });
        }
      } else {
        commit('setLoads', state[status]);
        // set pagination here as well
      }
    } catch (e) {
      console.log('error', e);
    } finally {
      commit('setLoading', false);
    }
  },
  async searchLoads(
    { commit, state },
    {
      page = 1,
      perPage = 50,
      query = {},
      sort = '',
      // sort = 'start_stop_scheduled_window_started_at+asc',
      refetch = false,
      // useExisting = false,
    }
  ) {
    if (!refetch) {
      commit('setLoading', true);
    }

    console.log('Load Search Query: ', query);
    console.log('Load Search Sort: ', sort);

    const body = {
      q: {
        ...buildLoadSearchQueryParams(query, sort),
      },
      page,
      per_page: perPage,
    };

    try {
      const res = await axios.post(
        `${process.env.API_MONITOR}/api/v1/loads/carrier_search`,
        body
      );

      if ([200, 201, 204].includes(res?.status) && res.data) {
        if (refetch) {
          const combinedState = {
            results: [
              ...(state.loads?.results || []),
              ...(res.data?.results || []),
            ],
          };

          commit('setLoads', combinedState);
          commit('setLoadboardPagination', {
            totalRecords: res.headers?.totalitems,
            totalPages: res.headers?.totalpages,
            currentPage: res.headers?.currentpage,
          });
        } else {
          commit('setLoads', res.data);
          commit('setLoadboardPagination', {
            totalRecords: res.headers?.totalitems,
            totalPages: res.headers?.totalpages,
            currentPage: res.headers?.currentpage,
          });
        }

        commit('setSearchLoadError', {});
      } else if ([422, 400].includes(res?.status)) {
        commit('setSetNotMeetingRequirements', true);
        commit('setSearchLoadError', res?.data?.error);
      } else {
        throw new Error('No data returned from API', { cause: res });
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        commit('setSetNotMeetingRequirements', true);
        commit('setSearchLoadError', error?.response?.data?.error);
      } else if (error?.message) {
        commit('setSetNotMeetingRequirements', true);
        commit('setSearchLoadError', error?.message);
      }
      console.log('error', error);
    } finally {
      commit('setLoading', false);
    }
  },
  async getLoadDetail({ commit }, { id, query = '', quiet = false }) {
    if (!quiet) {
      commit('setLoadDetailsLoading', true);
    }

    try {
      const res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/loads/${id}/${query}`
      );

      if ([200, 201, 204].includes(res?.status) && res.data) {
        commit('setLoadDetail', res.data);
      }
      return res;
    } catch (e) {
      console.log('error', e);
      return e;
    } finally {
      commit('setLoadDetailsLoading', false);
    }
  },
  async getLoadBoardDetail({ commit }, { id, quiet = false }) {
    if (!quiet) {
      commit('setLoadDetailsLoading', true);
    }

    try {
      const res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/loads/${id}/carrier_details`
      );

      if ([200, 201, 204].includes(res?.status) && res.data) {
        commit('setLoadDetail', {
          ...res.data,
          stops: res?.data?.stops?.map((stop) => ({
            ...stop,
            latitude_for_map: stop?.lat,
            longitude_for_map: stop?.lon,
          })),
        });
      }
      return res;
    } catch (e) {
      return { ...e?.response, data: e?.response?.data || {} };
    } finally {
      commit('setLoadDetailsLoading', false);
    }
  },
  clearLoad({ commit }) {
    // commit('setLoads', []);
    commit('setLoadLogs', []);
    commit('setHasLoadLogsLoaded', false);
    commit('setAlertVehicles', []);
    commit('setHasAlertVehiclesLoaded', false);
    commit('setLoadRoute', {});
    commit('setAssignedVehicle', {});
    commit('setHasAssignedVehicleLoaded', false);
  },
  async getLoadLogs({ commit }, { type = '', id }) {
    const { data, loaded, query } = getLoadLogsScope(type);
    try {
      commit(loaded, false);
      const res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/loads/${id}/load_logs${query}`
      );
      commit(loaded, true);
      if ([200, 201, 204].includes(res?.status) && res.data) {
        commit(data, res.data);
      } else {
        throw new Error('No data returned from API', { cause: res });
      }
      return res;
    } catch (e) {
      console.log('error', e);
      commit(loaded, true);
      commit(data, []);
    }
  },
  async getCarrierVehicles({ commit }, id) {
    try {
      let res = await axios.get(
        process.env.API_MONITOR +
          '/api/v1/carriers/' +
          id +
          '/eld_carrier_vehicles_for_carrier'
      );
      // let res = await axios.get(
      //   process.env.API_MONITOR +
      //     '/api/v1/carriers/' +
      //     id +
      //     '/eld_carrier_vehicles'
      // );
      if (res.status < 400 && res?.data) {
        commit('setEldCarrierVehicles', res.data.eld_carrier_vehicles || []);
        return res;
      } else {
        throw new Error('No data returned from API', { cause: res });
      }
    } catch (e) {
      // console.log('error', e);
      return e;
    }
  },
  async getUserTicketRole({ rootState, commit }) {
    let role = 'blocked';
    if (
      rootState.users.currentUser?.scopes?.includes(
        'tickets_load_lock_manager'
      ) ||
      rootState.users.currentUser?.scopes?.includes('compliance')
    ) {
      role = 'manager';
    } else {
      role = 'staff';
    }
    commit('setUserTicketRole', role);
  },
  async getAssignedVehicle({ commit }, loadId) {
    commit('setHasAssignedVehicleLoaded', false);
    try {
      let res = await axios.get(
        process.env.API_MONITOR +
          '/api/v1/loads/' +
          loadId +
          '/carrier_vehicle_area_trace_data'
      );
      if (res.status < 400 && res?.data) {
        commit('setAssignedVehicle', res.data);
        return res;
      } else {
        throw new Error('No data returned from API', { cause: res });
      }
    } catch (e) {
      // console.log('error', e);
      return e;
    } finally {
      commit('setHasAssignedVehicleLoaded', true);
    }
  },
  async getNearbyVehicles({ commit }, loadId) {
    commit('setHasNearByVehiclesLoaded', false);
    try {
      let res = await axios.get(
        process.env.API_MONITOR +
          '/api/v1/loads/' +
          loadId +
          '/recent_carrier_vehicle_areas_by_carrier_vehicle'
      );

      commit('setHasNearByVehiclesLoaded', true);
      if (res.status < 400 && res?.data) {
        commit('setNearByVehicles', res.data);
        return res;
      } else {
        throw new Error('No data returned from API', { cause: res });
      }
    } catch (error) {
      commit('setHasNearByVehiclesLoaded', true);
      commit('setNearByVehicles', []);
      // console.log('error', error);
      return error;
    }
  },
  async getRoute({ commit }, { type = 'load', coordinates }) {
    const token = process.env.MAPBOX_TOKEN;
    const { loading, data } = getRouteScope(type);
    try {
      commit(loading, true);
      const response = await axios.get(
        `https://api.mapbox.com/directions/v5/mapbox/driving/${coordinates}?steps=true&geometries=geojson&avoid_maneuver_radius=1000&overview=full&access_token=${token}`
      );
      let route = {};
      if (response.data.routes.length) {
        route = response.data.routes[0].geometry;
      } else {
        commit(loading, false);
        throw new Error('No data returned from API', { cause: response });
      }
      commit(data, route);
      commit(loading, false);
      return route;
    } catch (e) {
      console.log('error', e);
      commit(data, {});
      commit(loading, false);
    }
  },
  async patchLoad(_, options) {
    try {
      const res = await axios.patch(
        process.env.API_MONITOR + '/api/v1/loads/' + options.id,
        options.payload
      );
      // for testing vehicle assignment with json-server
      // const res = await axios.patch(
      //   `http://localhost:4000/load`,
      //   options.payload
      // );
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getLaneSearchHistory({ commit }) {
    commit('setIsLaneSearchHistoryLoading', true);
    try {
      const res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/carrier_lane_search_histories/recent`
      );
      commit('setIsLaneSearchHistoryLoading', false);
      if ([200, 201, 204].includes(res?.status) && res.data) {
        commit('setLaneSearchHistory', res.data);
      } else {
        throw new Error('No data returned from API', { cause: res });
      }
      return res;
    } catch (e) {
      commit('setIsLaneSearchHistoryLoading', false);
      console.log('error', e);
    }
  },
  async getEquipmentTypes({ commit }) {
    try {
      const res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/loads/posted_equipment_types_with_descriptions`
      );

      if ([200, 201, 204].includes(res?.status) && res.data) {
        commit('setEquipmentTypes', res.data);
      } else {
        throw new Error('No data returned from API', { cause: res });
      }
      return res;
    } catch (e) {
      console.log('error', e);
    }
  },
  async getTruckPostings(
    { commit, state },
    { query = '', page = 1, quiet = false, refetch = false }
  ) {
    if (!quiet) {
      commit('setTruckPostingLoading', true);
    }

    try {
      const res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/truck_postings${query}&page=${page}`
      );

      if ([200, 201, 204].includes(res?.status) && res.data) {
        if (refetch) {
          const combinedTruckPostings = [...state.truck_postings, ...res.data];
          commit('setTruckPostings', combinedTruckPostings);
        } else {
          commit('setTruckPostings', res.data);
        }

        commit('setTruckPostingsPagination', {
          totalRecords: Number(res.headers?.totalitems),
          totalPages: Number(res.headers?.totalpages),
          currentPage: Number(res.headers?.currentpage),
        });
      } else {
        throw new Error('No data returned from API', { cause: res });
      }
      return res;
    } catch (e) {
      console.log('error', e);
    } finally {
      commit('setTruckPostingLoading', false);
    }
  },
  async getExpiredTruckPostings(
    { commit, state },
    { page = 1, refetch = false }
  ) {
    if (!refetch) {
      commit('setExpiredTruckPostingLoading', true);
    }

    try {
      const res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/truck_postings?q[is_active_eq]=0&page=${page}`
      );

      if ([200, 201, 204].includes(res?.status) && res.data) {
        if (refetch) {
          const combinedExpiredTruckPostings = [
            ...state.expired_truck_postings,
            ...res.data,
          ];

          commit('setExpiredTruckPostings', combinedExpiredTruckPostings);
        } else {
          commit('setExpiredTruckPostings', res.data);
        }

        commit('setExpiredTruckPostingsPagination', {
          totalRecords: Number(res.headers?.totalitems),
          totalPages: Number(res.headers?.totalpages),
          currentPage: Number(res.headers?.currentpage),
        });
      } else {
        throw new Error('No data returned from API', { cause: res });
      }
      return res;
    } catch (e) {
      console.log('error', e);
    } finally {
      commit('setExpiredTruckPostingLoading', false);
    }
  },
  async createTruckPosting({ dispatch, commit }, body) {
    commit('setCreateTruckPostingLoading', true);

    const params = {
      truck_posting: body,
    };

    try {
      const res = await axios.post(
        `${process.env.API_MONITOR}/api/v1/truck_postings`,
        params
      );

      if ([200, 201, 204].includes(res?.status) && res.data) {
        dispatch('getTruckPostings', {
          query: '?q[is_active_eq]=1',
          quiet: true,
        });
      }
      return res;
    } catch (error) {
      console.log('error', error);
      commit('setTruckPostingError', error?.response?.data);
      return error;
    } finally {
      commit('setCreateTruckPostingLoading', false);
    }
  },
  async updateTruckPosting({ dispatch, commit }, body) {
    commit('setCreateTruckPostingLoading', true);
    const { id, ...rest } = body;
    const params = {
      truck_posting: rest,
    };

    try {
      const res = await axios.patch(
        `${process.env.API_MONITOR}/api/v1/truck_postings/${id}`,
        params
      );

      if ([200, 201, 204].includes(res?.status) && res.data) {
        dispatch('getTruckPostings', {
          query: '?q[is_active_eq]=1',
          quiet: true,
        });

        if (body?.is_active === false) {
          dispatch('getExpiredTruckPostings');
        }
      }
      return res;
    } catch (e) {
      console.log('error', e);
      return e;
    } finally {
      commit('setCreateTruckPostingLoading', false);
    }
  },
  async sendCarrierToOnboarding({ commit }, id) {
    commit('setCarrierOnboardingLoading', true);

    try {
      const res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/loads/${id}/send_carrier_to_onboarding`
      );

      return res;
    } catch (e) {
      console.log('error', e);
      return e;
    } finally {
      commit('setCarrierOnboardingLoading', false);
    }
  },
};

const mutations = {
  setLoading(state, bool) {
    state.isLoadsLoading = bool;
  },
  setLoads(state, data) {
    state.loads = data;
  },
  setDispatchLoads(state, data) {
    state.dispatch = data;
  },
  setTransitLoads(state, data) {
    state.transit = data;
  },
  setCompletedLoads(state, data) {
    state.completed = data;
  },
  setDispatchQuery(state, data) {
    state.existing_dispatch_query = data;
  },
  setTransitQuery(state, data) {
    state.existing_transit_query = data;
  },
  setCompletedQuery(state, data) {
    state.existing_completed_query = data;
  },
  setDispatchPagination(state, data) {
    state.dispatch_pagination = data;
  },
  setTransitPagination(state, data) {
    state.transit_pagination = data;
  },
  setCompletedPagination(state, data) {
    state.completed_pagination = data;
  },
  setLoadboardPagination(state, data) {
    state.loadboard_pagination = data;
  },
  setLoadDetail(state, data) {
    state.load_details = data;
  },
  setLoadDetailsLoading(state, data) {
    state.isLoadDetailsLoading = data;
  },
  setEldCarrierVehicles(state, data) {
    state.eld_carrier_vehicles = data;
  },
  setAssignedVehicle(state, data) {
    state.assigned_vehicle = data;
  },
  setDestinationRoute(state, route) {
    state.destination_route = route;
  },
  setDestinationRouteLoading(state, bool) {
    state.load_route_loading = bool;
  },
  setLoadRoute(state, bool) {
    state.load_route = bool;
  },
  setLoadRouteLoading(state, bool) {
    state.load_route_loading = bool;
  },
  setHasAssignedVehicleLoaded(state, bool) {
    state.has_assigned_vehicle_loaded = bool;
  },
  setHasNearByVehiclesLoaded(state, bool) {
    state.has_near_by_vehicles_loaded = bool;
  },
  setNearByVehicles(state, data) {
    state.near_by_vehicles = data;
  },
  setHasAlertVehiclesLoaded(state, bool) {
    state.has_alert_vehicles_loaded = bool;
  },
  setUserTicketRole(state, role) {
    state.user_ticket_role = role;
  },
  setAlertVehicles(state, data) {
    state.alert_vehicles = data;
  },
  setHasLoadLogsLoaded(state, bool) {
    state.has_load_logs_loaded = bool;
  },
  setLoadLogs(state, data) {
    state.load_logs = data;
  },
  setDispatchFilters(state, data) {
    state.dispatch_filters = data;
  },
  setTransitFilters(state, data) {
    state.transit_filters = data;
  },
  setCompletedFilters(state, data) {
    state.completed_filters = data;
  },
  setDispatchParams(state, data) {
    state.dispatch_params = data;
  },
  setTransitParams(state, data) {
    state.transit_params = data;
  },
  setCompletedParams(state, data) {
    state.completed_params = data;
  },
  setCurrentLoadStatus(state, data) {
    state.current_load_status = data;
  },
  setLoadSearchFilters(state, data) {
    state.loadSearchFilters = data;

    const originDeadhead = data?.origin_deadhead
      ? `${data?.origin_deadhead}${data?.origin_deadhead?.toString()?.includes('mi') ? '' : ' mi'}`
      : '';

    const destinationDeadhead = data?.destination_deadhead
      ? `${data?.destination_deadhead}${data?.destination_deadhead?.toString()?.includes('mi') ? '' : ' mi'}`
      : '';

    localStorage.setItem(
      'load_search_filters',
      JSON.stringify({
        ...data,
        origin_deadhead: originDeadhead,
        destination_deadhead: destinationDeadhead,
      })
    );
  },
  setSearchLoadError(state, data) {
    state.search_load_error = data;
  },
  setIsLaneSearchHistoryLoading(state, bool) {
    state.isLaneSearchHistoryLoading = bool;
  },
  setLaneSearchHistory(state, data) {
    state.lane_search_history = data;
  },
  setEquipmentTypes(state, data) {
    state.equipment_types = data;
  },
  setTruckPostingLoading(state, bool) {
    state.is_truck_postings_loading = bool;
  },
  setTruckPostings(state, data) {
    state.truck_postings = data;
  },
  setTruckPostingsPagination(state, headers) {
    state.truck_postings_pagination = headers;
  },
  setExpiredTruckPostings(state, data) {
    state.expired_truck_postings = data;
  },
  setExpiredTruckPostingsPagination(state, headers) {
    state.expired_truck_postings_pagination = headers;
  },
  setCreateTruckPostingLoading(state, bool) {
    state.is_create_truck_posting_loading = bool;
  },
  setExpiredTruckPostingLoading(state, bool) {
    state.is_expired_truck_posting_loading = bool;
  },
  setTruckPostingError(state, data) {
    state.truck_posting_error = data;
  },
  setPreLoadResponse(state, data) {
    state.preloaded_load_response = data;
  },
  setCarrierOnboardingLoading(state, bool) {
    state.is_carrier_connect_button_loading = bool;
  },
};

export default {
  namespaced: true,
  state,
  // getters,
  actions,
  mutations,
};
